<template>
  <div class="content">
    <div>
      <img
        class="faq-log"
        :src="require('@/assets/web/logo_foot.jpg')"
        alt=""
      />
    </div>
    <div class="text-left">
      <div class="mb-8">
        For any further questions please contact us
      </div>
      <p class="mt-2">General Enquiries:</p>
      <a class="ml-12 hover:underline" href="mailto:support@sidequestmeta.com">support@sidequestmeta.com</a>
      <p class="mt-2">Events and Bookings:</p>
      <a class="ml-12 hover:underline" href="mailto:event@sidequestmeta.com">charingcross@sidequesthub.co.uk</a>
      <p class="mt-2">Franchisees:</p>
      <a class="ml-12 hover:underline" href="mailto:invest@sidequestmeta.com">charingcross@sidequesthub.co.uk</a>
      <p class="mt-2">Gaming events / Bootcamps / Venue hire:</p>
      <a class="ml-12 hover:underline" href="mailto:events@sidequestmeta.com">charingcross@sidequesthub.co.uk</a>
      <p class="mt-2">Fan events (Kpop etc) / Marketing / Universities & Student bookings:</p>
      <a class="ml-12 hover:underline" href="mailto:media@sidequestmeta.com">charingcross@sidequesthub.co.uk</a>
      <p class="mt-2">Student Society:</p>
      <a class="ml-12 hover:underline" href="/about?id=third">Link to page</a>
    </div>

  </div>

  <div class="flex place-content-center mt-6">
    <span class="dialog-footer">
      <el-button class="button-ok" type="primary" @click="emit('onClose')"
        >OK</el-button
      >
    </span>
  </div>
</template>

<script setup>
const emit = defineEmits(["onClose"]);
</script>

<style scoped lang="scss">
@use "@/styles/base" as *;

.content {
  width: 60vw;
  max-width: 540px;
  margin: 24px;
}

.button-ok {
  @include button-base;
  color: black;
}
</style>
